export default "__VITE_ASSET__BDY4dFYC__"